/**
 * Login Page
 *
 * OKTA login page with redirect to dashboard
 */

import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';
import { APP_NAME, ROUTES } from '../config/constants';
import { SUPPORTED_REGIONS, getSelectedRegion, setSelectedRegion } from '../config/okta';
import './Login.css';

const REGION_LABELS = { AMER: 'Americas (AMER)', EMEA: 'Europe & Middle East (EMEA)', APAC: 'Asia Pacific (APAC)' };

const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const history = useHistory();
  const [region, setRegion] = useState(getSelectedRegion());

  useEffect(() => {
    if (authState?.isAuthenticated) {
      history.push(ROUTES.DASHBOARD);
    }
  }, [authState, history]);

  const handleRegionChange = (e) => {
    const selected = e.target.value;
    setSelectedRegion(selected);
    setRegion(selected);
    window.location.reload();
  };

  const handleLogin = async () => {
    try {
      await oktaAuth.signInWithRedirect();
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login">
      <div className="login__card">
        <div className="login__logo">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <rect width="64" height="64" rx="12" fill="#0066CC" />
            <path
              d="M16 24h32M16 32h32M16 40h32"
              stroke="white"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <h1 className="login__title">{APP_NAME}</h1>
        <p className="login__subtitle">Manage product readiness intake processes</p>

        <div className="login__region">
          <label className="login__region-label" htmlFor="region-select">Your Region</label>
          <select
            id="region-select"
            className="login__region-select"
            value={region}
            onChange={handleRegionChange}
          >
            {SUPPORTED_REGIONS.map(r => (
              <option key={r} value={r}>{REGION_LABELS[r]}</option>
            ))}
          </select>
        </div>

        <button className="login__button" onClick={handleLogin}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M10 2a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V3a1 1 0 011-1z"
              clipRule="evenodd"
            />
          </svg>
          Sign In with OKTA
        </button>

        <p className="login__help">
          Authentication is provided by OKTA SSO. Contact IT support if you need access.
        </p>
      </div>
    </div>
  );
};

export default Login;
